<template>
  <div
    v-if="visible"
    class="fixed bottom-0 left-0 right-0 border-t border-gray-200 bg-white px-4 py-4 shadow-lg sm:px-6"
    style="z-index: 7000"
  >
    <div class="mx-auto flex max-w-5xl flex-col items-start gap-4 sm:flex-row sm:items-center">
      <p class="flex-1 text-sm text-gray-700">
        {{ texts.message }}
      </p>
      <div class="flex w-full flex-shrink-0 gap-3 sm:w-auto">
        <button
          type="button"
          class="flex-1 rounded border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 sm:flex-none"
          @click="refuse"
        >
          {{ texts.refuse }}
        </button>
        <button
          type="button"
          class="flex-1 rounded px-4 py-2 text-sm font-medium text-white hover:opacity-90 sm:flex-none"
          style="background-color: #667eea"
          @click="accept"
        >
          {{ texts.accept }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  analyticsId,
  getConsent,
  setConsent,
  initAnalytics,
  trackPageView,
} from '~/analytics';

const MESSAGES = {
  fr: {
    message:
      'Nous utilisons des cookies de mesure d’audience (Google Analytics) pour améliorer ComptaCrypto. Vous pouvez accepter ou refuser ces cookies, votre choix sera conservé pendant 6 mois.',
    accept: 'Accepter',
    refuse: 'Refuser',
  },
  en: {
    message:
      'We use analytics cookies (Google Analytics) to improve ComptaCrypto. You can accept or refuse these cookies; your choice will be stored for 6 months.',
    accept: 'Accept',
    refuse: 'Refuse',
  },
};

export default {
  data() {
    return {
      // Only show the banner when analytics are configured and no choice
      // has been made yet.
      visible: !!analyticsId() && !getConsent(),
    };
  },
  computed: {
    texts() {
      return MESSAGES[document.documentElement.lang] || MESSAGES.en;
    },
  },
  methods: {
    accept() {
      setConsent('accepted');
      this.visible = false;
      initAnalytics();
      // The initial Inertia 'navigate' already fired before consent, so
      // track the current page explicitly.
      trackPageView();
    },
    refuse() {
      setConsent('refused');
      this.visible = false;
    },
  },
};
</script>
